<template>
<div class="class-topbar">
    <div class="navigation-topbar">
        <div class="back-to-plan" @click="$redirect(breadcrumbItems[0].href)">
            <i class="navigation-icon fas fa-chevron-left"/>
            <h3> {{ breadcrumbItems[0].text || $t('class.back_to_plan')}}</h3>
        </div>
        <h3> {{ this.contentItem && this.contentItem.translation && this.contentItem.translation.name }} </h3>
    </div>
    <class-topbar-certificate
        v-if="content 
            && content.hasCertificate
            && this.contentItem.progress >= this.contentItem.certificateProgress"
    />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClassTopbarCertificate from './ClassTopbarCertificate';

export default {
    name: 'ClassTopbar',

    components: { ClassTopbarCertificate },

    props: { breadcrumb: String },

    computed: {
        ...mapGetters({
            contentItem: 'CLASS_CONTENT_ITEM',
            content: 'CLASS_CONTENT',
        }),
        breadcrumbItems() { return JSON.parse(this.breadcrumb); },
    },

};
</script>

<style lang="scss" scoped>
.class-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    padding: 0 16px;
    background-color: #e0e0e0;
    h3 { margin-bottom: 0 }
    .navigation-topbar {
        display: flex;
        align-items: center;
        gap: 22px;
    }
    .back-to-plan {
        cursor: pointer;
        display: flex;
        align-items: center;
        .navigation-icon {
            font-size: 16px;
            margin-right: 10px;
        }
        h3 {
            position: relative;
            &::before {
                height: 100%;
                content: '';
                position: absolute;
                right: -14px;
                width: 2px;
                background-color: black;
            }
        }
    }

}
</style>
